import React, { useState, useEffect } from 'react'
import DataGrid from '../../../../components/DataGrid'
import { consultar } from '../../../../util/AcessoApi'


const ConsultaCbos = (props) => {
    const [data, setData] = useState([])

    useEffect(() => {
        consultar('/parametros/cbos', (dados) => setData(dados.sort((a, b) => b.id - a.id)))
    }, [])

    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-cbos',
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'codigo' ,
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }                  
                    },
                    {
                        Header: 'Descrição',
                        accessor: 'descricao',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            tipo: 'combo'
                        }
                    },
                    {
                        Header: 'Especialidade Médica?',
                        accessor: 'especialidade',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            tipo: 'combo-simples'
                        }
                    },
                    {
                        Header: 'Data Registro',
                        accessor: 'data_registro_formatada',
                        ordenamento: {
                            tipo: 'data'
                        },
                    },
                ],
            },
        ],
        []
    )
    const caminho = {
        cadastro: '/parametros/cbos/cadastro',
    }

    return (
        <>
            <div>
                <DataGrid data={data} columns={columns} caminhoBase='/parametros/cbos' setData={setData} acoes={true} url={caminho} modulo={props.modulo} 
                titulo={'Consulta CBOS'} tituloLista={'Lista CBOS'} urlCadastro='/parametros/cbos/cadastro' icone={'icon-Medical-Sign'}/>
            </div>
        </>
    )
}

export default ConsultaCbos